module.exports = "/assets/close-feedback-80fb73bde4a516c6ccf6207314cd87cf.svg";